<div class="row col-12 p-0 m-0 main-page-section">
    <div class="col-12 p-0 companies-section">
        <!-- <app-header></app-header> -->
        <div class="col-height">

            <div>
                <!-- <div class="breadcrumbs-section padding-left">
                    <span class="prev-page pt-1 "><a routerLink="/overview">Home</a></span>
                    <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
                    <span class="prev-page pt-1 "><a routerLink="/facility">Meeting Room</a></span>
                    <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
                    <span class="curr-page  breadcrumbs-section-font">{{meetingRoomDetails?.roomName}}</span>
                </div> -->

                <div class="breadcrumbs-section pl-2 ml-5">
                    <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
                    <img src="../../assets/images/seperator.png">
                    <span class="prev-page pr-2 pl-2 prev" routerLink="/company">Companies</span>
                    <img src="../../assets/images/seperator.png">
                    <span class="curr-page pr-2 pl-2 prev" [routerLink]="['/company/details', taId]">Company
                        Details</span>
                    <img src="../../assets/images/seperator.png">
                    <span class="curr-page pl-2 breadcrumbs-section-font prev"
                        [routerLink]="['/company/view-meeting-room', taId]">Meeting Room List</span>
                    <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
                    <span class="curr-page breadcrumbs-section-font">{{meetingRoomDetails?.roomName}}</span>
                </div>
            </div>

            <div class="add-bulletin-layout">

                <div class="row">
                    <div class="col-4">
                        <h1>{{meetingRoomDetails?.roomName}}</h1>
                    </div>

                    <!-- <div class="col-2"><button class="view-booking" (click)="bookFacility()" *ngIf="meetingRoomCreate">Block
                Facility</button></div>
            <div class="col-2"><button class="view-booking" (click)="blockedFacility()" *ngIf="meetingRoomCreate">View
                Blocked Calendars</button>
            </div> -->
                    <!-- <div class="col-2"><button class="view-booking" (click)="viewBoooking()">View Booking</button></div> -->

                    <div class="col-1" *ngIf="meetingRoomRemove">
                        <button class="delete-button" type="submit" (click)="openModal()"><img
                                src="../../../assets/images/delete_black_24dp copy 4.png"></button>
                    </div>
                    <div class="col-2" *ngIf="meetingRoomEdit">
                        <button type="submit" (click)="editDetail(meetingRoomId)">Edit</button>
                    </div>
                </div>

                <ng-template #contentActivation let-modal class="text-center">
                    <div class="modal-height">
                        <div class="modal-body">
                            <div class="">
                                <div class="text pt-3 pb-3">Are you sure, you want to Delete?</div>
                                <div class="popup-line"></div>
                            </div>
                        </div>
                        <div class="submit col-12 d-flex justify-content-end ">
                            <div class="pr-3">
                                <button type="button " class="cancel-button pt-3"
                                    (click)="modal.close('Save click')"><span class="cancel">Cancel</span></button>
                            </div>
                            <button type="button " (click)=" modal.close('Save click');deleteMeetingRoom()"
                                class="add-button"><span class="add">Delete</span></button>

                        </div>
                    </div>
                </ng-template>

                <!-- <div class="row mt-3">
                    <div class="col-12 text">
                        Zone
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12 title-text">
                        {{meetingRoomDetails?.taxZoneType|titlecase}}
                    </div>
                </div> -->

                <div class="row">
                    <div class="col-11">

                        <div class="row mt-3">

                            <div class="col-12 ">
                                <img *ngIf="meetingRoomDetails?.parkMeetingRoomImagesList==null || meetingRoomDetails?.parkMeetingRoomImagesList==''"
                                    src='../../../assets/images/placeholder.png'>
                            </div>

                            <div *ngIf="meetingRoomDetails?.parkMeetingRoomImagesList.length>0" class="pl-3">

                                <img [src]="meetingRoomDetails?.parkMeetingRoomImagesList[urlIndex].imageURL"
                                    class="mb-3 pr-3" />
                                <div class="row" style="margin-top: -50px;">
                                    <div class="col-5"></div>
                                    <div class="col-4">
                                        <button
                                            *ngFor="let item of meetingRoomDetails?.parkMeetingRoomImagesList;let i = index"
                                            [ngClass]="urlIndex==i?'bubble-button-active':'bubble-button'" type="submit"
                                            (click)="displayImg(i)"></button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-4" *ngIf="meetingRoomDetails?.description">
                            <div class="col-12 text">
                                Description
                            </div>
                        </div>

                        <div class="row mt-2" *ngIf="meetingRoomDetails?.description">
                            <div class="col-12 title-text">
                                {{meetingRoomDetails?.description|titlecase}}
                            </div>
                        </div>

                        <hr>

                        <div class="row mt-4" *ngIf="meetingRoomDetails?.minBookingDuration">
                            <div class="col-12 text">
                                Minimum Booking Duration(Hours)
                            </div>
                        </div>

                        <div class="row mt-2" *ngIf="meetingRoomDetails?.minBookingDuration">
                            <div class="col-12 title-text">
                                {{meetingRoomDetails?.minBookingDuration}}
                            </div>
                        </div>

                        <div class="row mt-4" *ngIf="meetingRoomDetails?.maxBookingDuration">
                            <div class="col-12 text">
                                Maximum Booking Duration(Hours)
                            </div>
                        </div>

                        <div class="row mt-2" *ngIf="meetingRoomDetails?.maxBookingDuration">
                            <div class="col-12 title-text">
                                {{meetingRoomDetails?.maxBookingDuration || 'NA'}}
                            </div>
                        </div>

                        <hr *ngIf="meetingRoomDetails?.minBookingDuration">

                        <div class="row mt-4" *ngIf="meetingRoomDetails?.minAutoCancelDuration">
                            <div class="col-12 text">
                                Booking Auto Cancel Duration(Minutes)
                            </div>
                        </div>

                        <div class="row mt-2" *ngIf="meetingRoomDetails?.minAutoCancelDuration">
                            <div class="col-12 title-text">
                                {{meetingRoomDetails?.minAutoCancelDuration}}
                            </div>
                        </div>

                        <hr *ngIf="meetingRoomDetails?.minAutoCancelDuration">

                        <div class="row mt-4">
                            <div class="col-12 text">
                                Maintenance Day(s)
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-12 title-text"
                                *ngIf="meetingRoomDetails?.parkMeetingRoomMaintainanceDetail.length > 0">
                                {{meetingRoomDetails?.parkMeetingRoomMaintainanceDetail[0].maintainanceDetailDescription
                                ?? 'NA'}}
                            </div>
                            <div class="col-12 title-text"
                                *ngIf="meetingRoomDetails?.parkMeetingRoomMaintainanceDetail.length == 0">
                                No Date Selected
                            </div>
                        </div>

                        <hr
                            *ngIf="meetingRoomDetails?.fromDayOperation != '' && meetingRoomDetails?.toDayOperation != ''">

                        <div
                            *ngIf="meetingRoomDetails?.fromDayOperation != '' && meetingRoomDetails?.toDayOperation != ''">
                            <div class="row mt-4">
                                <div class="col-12 text">
                                    Operation Day(s)
                                </div>
                            </div>

                            <div class="row mt-2">
                                <div class="col-12 title-text">
                                    <!-- 21 Apr, 2021 to 22 Apr, 2021 -->
                                    {{meetingDayFromName}} to
                                    {{meetingDayToName}}
                                </div>
                            </div>
                        </div>

                        <hr *ngIf="isOperationDaysShow">

                        <div class="row" *ngIf="isOperationDaysShow">
                            <div class="col-12 text">
                                Operation Hour(s)
                            </div>
                        </div>

                        <div class="row mt-2 mb-4" style="display: none;">
                            <div class="col-12 title-text"
                                *ngFor="let listtimeslab of TempRateCardHourCal; let i=index;">
                                <div class="row">
                                    <div class="col-12 title-text">
                                        {{i+1}}. Rate - ₹{{listtimeslab?.hourRate || 0}} From -
                                        {{listtimeslab?.stimerate}}
                                        To -
                                        {{listtimeslab?.etimerate}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-4 title-text" style="display: none;">
                                ₹{{meetingRoomDetails?.dailyRate || 0}} <span class="text pl-1 pr-1">for</span> 1 day
                            </div>
                            <div class="col-4 text" style="display: none;">
                                Additional day rate<span
                                    class="title-text pl-1">₹{{meetingRoomDetails?.additionalDayRate || 0}}</span>
                            </div>

                            <div class="col-4" *ngIf="isOperationDaysShow">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 text">
                                                Start Time
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 title-text mt-3">
                                                {{formatDate(meetingRoomDetails?.operationStartTime,'time')}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 text">
                                                End Time
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 title-text mt-3">
                                                {{formatDate(meetingRoomDetails?.operationEndTime,'time')}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <hr *ngIf="meetingRoomDetails?.facilityType!=='Space on rent'">
              <div class="row mt-4"
                *ngIf="meetingRoomDetails?.facilityType!=='Space on rent'&&meetingRoomDetails?.securityDeposit">
                <div class="col-12 text">
                  Security Deposit (Refundable)
                </div>
              </div>
              <div class="row mt-2"
                *ngIf="meetingRoomDetails?.facilityType!=='Space on rent'&&meetingRoomDetails?.securityDeposit">
                <div class="col-12 title-text">
                  ₹{{meetingRoomDetails?.securityDeposit}}
                </div>
              </div> -->

                        <hr>

                        <div class="row">
                            <div class="col-6" *ngIf="meetingRoomDetails?.capacity">
                                <div class="row">
                                    <div class="col-12 text mt-3">
                                        Booking Capacity
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 title-text mt-3">
                                        {{meetingRoomDetails?.capacity}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr *ngIf="meetingRoomDetails?.capacity">

                        <div style="display: none;">
                            <div class="row">
                                <div class="col-12 text">
                                    Cancellation & Policies
                                </div>
                            </div>

                            <div class="row mt-3">

                                <div class="col-2"><input type="radio" [checked]="true"
                                        style="display: none;cursor: pointer;" id="pol" value="pol" name="typ"
                                        (click)="selectType($event)"><label style="cursor: pointer;"
                                        [ngClass]="type=='pol'?'checked':'check'" for="pol">Policies</label>
                                </div>
                                <!-- <div class="col-2"><input type="radio" [checked]="true"
                                        style="display: none;cursor: pointer;" id="cal" value="cal" name="typ"
                                        (click)="selectType($event)"><label [ngClass]="type=='cal'?'checked':'check'"
                                        for="cal" style="cursor: pointer;">Calculation</label>
                                </div> -->
                            </div>
                            <div class="row">
                                <div class="col-10" style="position: inherit; margin-top: -25px;">
                                    <hr>
                                </div>
                                <div class="col-2"></div>
                            </div>

                            <div *ngIf="showPolicy && meetingRoomDetails?.parkMeetingRoomPoliciesList.length > 0">

                                <div *ngFor="let list of meetingRoomDetails?.parkMeetingRoomPoliciesList; let i=index;">
                                    <div class="row">
                                        <div class="col-12 title-text" *ngIf="list?.policyDescription != ''">
                                            {{i+1}}. {{list?.policyDescription|titlecase}}
                                        </div>
                                        <div class="col-12 title-text" *ngIf="list?.policyDescription == ''">
                                            No Data Available.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="showPolicy && meetingRoomDetails?.parkMeetingRoomPoliciesList.length == 0">
                                No Data Available.
                            </div>
                        </div>

                        <div *ngIf="showCal" style="display: none;">
                            <div *ngFor="let list of meetingRoomDetails?.parkMeetingRoomCancellationCalcsList">
                                <div class="row mt-2">
                                    <div class="col-4 text-small">Unit Type</div>
                                    <div class="col-4 text-small">No. of {{list?.unitType}} prior</div>
                                    <div class="col-4 text-small">Amount Deducted (in %)</div>
                                </div>
                                <div class="row">
                                    <div class="col-4 title-text">{{list?.unitType}}</div>
                                    <div class="col-4 title-text">{{list?.timePrior}}</div>
                                    <div class="col-4 title-text">{{list?.amountDeducted}}</div>
                                </div>
                            </div>
                        </div>

                        <!-- <hr> -->

                        <!-- <div class="row mt-4">
                            <div class="col-12 text">
                                <h2>Amenities</h2>
                            </div>
                        </div>

                        <div *ngFor="let listaminities of meetingRoomDetails?.meetingAmenityResponseList; let i=index;">
                            <div class="row">
                                <div class="col-12 title-text">
                                    {{i+1}}. {{listaminities?.amenityName|titlecase}}
                                </div>
                            </div>
                        </div> -->

                        <div class="amenities">
                            <div class="row mt-4">
                                <div class="col-12 text">
                                    <h2>Amenities</h2>
                                </div>
                            </div>

                            <div class="row m-0" *ngIf="meetingRoomDetails?.meetingAmenityResponseList.length > 0">
                                <div class="col-10">
                                    <button
                                        *ngFor="let listaminities of meetingRoomDetails?.meetingAmenityResponseList; let i=index;"
                                        [ngClass]="(selectedAminity.includes(listaminities.amenitiesId))?'button-onselect':'button-before'"
                                        class="mr-2 mb-3" type="submit">
                                        <img class="icon" src={{listaminities.imageURL}}>
                                        {{listaminities.amenityName}}
                                    </button>
                                </div>
                            </div>
                            <div class="row" *ngIf="meetingRoomDetails?.meetingAmenityResponseList.length == 0">
                                <div class="col-12 title-text">
                                    No Amenities Available
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row mt-4">
                            <div class="col-12 text">
                                <h2>Terms & Conditions</h2>
                            </div>
                        </div>

                        <div *ngFor="let list of meetingRoomDetails?.parkMeetingRoomTermsList; let i=index;">
                            <div class="row">
                                <div class="col-12 title-text">
                                    {{i+1}}. {{list?.termDescription|titlecase}}
                                </div>
                            </div>
                        </div>

                        <!-- <hr>

                        <div class="contact-info">
                            <p>Contact Info</p>
                            <div class="row"
                                *ngFor="let list of meetingRoomDetails?.parkMeetingRoomContactList; let i=index;">

                                <div class="col-5">

                                    <p class="contact-title">Mobile number</p>
                                    <p class="contact-output">{{list?.contactNumber}}</p>
                                </div>
                                <div class="col-6">
                                    <p class="contact-title">Email Id</p>
                                    <p class="contact-output">{{list?.contactEmail}}</p>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="col-1"></div>
                </div>
            </div>
        </div>